var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('app-view-common-insight_play-name',{attrs:{"item":_vm.item,"field":_vm.field}}),_c('app-view-common-insight_play-stats',{attrs:{"item":_vm.item,"field":_vm.field}}),(_vm.field.players === 'enabled')?_c('app-view-common-insight_play-players',{attrs:{"item":_vm.item,"field":_vm.field}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }